import { HttpClient } from '@angular/common/http';
import { Component, HostBinding, ViewChild } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment-timezone';
import {
  BookingDayCalendarBase,
  DaySection,
} from '../common/components/dayview/dayview.base';
import {
  DayViewTimeColumn,
  DayViewTimeComponent,
  DayViewTimeItem,
  DayViewTimeLoad,
  DayViewTimeRow,
} from '../common/components/dayview/dayview.time.component';
import { VizFormModule } from '../common/components/form/form.module';
import { date_utils } from '../common/date_utils';
import { TimeAtom } from '../common/timespan/time_utils';
import { WebUtils } from '../common/utils';
import { AccessUtils, TBooking, TLocation, TSpace } from '../core/entities';
import { SessionCache } from '../session.cache';
import { SessionService } from '../session.service';
import { BookingMixin } from '../thinkdesks/booking.mixin';
import { SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { Thinkdesks } from '../thinkdesks/thinkdesks';
import { ThinkdesksCache } from '../thinkdesks/thinkdesks.cache';
import { TBookingStatus } from '../thinkdesks/thinkdesks.entities';
import { BookingDialogComponent } from './booking.dialog.component';
import { BookingSelectDialog } from './booking.select.dialog';
// import { BookingDialogComponent } from './booking.dialog.component';
// import { BookingSpaceDialog } from './booking.space.dialog';
// import { BookingSpaceSelectDialogComponent } from './booking.space.select.dialog';

function rowFormat(row: DayViewTimeRow) {
  let now = moment();
  let d = row.start.moment(now);
  return d.format(Thinkdesks.timeFormat);
}
@Component({
  selector: 'app-booking-space-calendar',
  standalone: true,
  imports: [
    VizFormModule,
    MatDialogModule,
    MatSelectModule,
    DayViewTimeComponent,
    MatToolbarModule,
    FontAwesomeModule,
    MatDatepickerModule,
  ],
  templateUrl: './booking.space.calendar.component.html',
})
export class BookingSpaceCalendarComponent extends BookingMixin(
  SiteFormatMixin(BookingDayCalendarBase)
) {
  @HostBinding('class') css = 'max-height';
  _common = _common;

  spaces: TSpace[] = [];
  space: TSpace;
  locations: TLocation[] = [];
  location: TLocation;

  date = moment();
  rowFormat = rowFormat;
  constructor(
    private cache: SessionCache,
    private dialog: MatDialog,
    private http: HttpClient,
    override session: SessionService,
    private thinkDesksCache: ThinkdesksCache
  ) {
    super();
    this.cache.loadManagedLocation(this.session, (list) => {
      this.locations = list;

      this.thinkDesksCache.loadSpaceByLocations(
        this.session.locations.map((c) => c.id),
        (list) => {
          this.spaces = list;
          this.space = this.spaces[0];
          this.location = this.locations.find((c) => c.id == this.space.location.id)
        }
      );

    });

    // this.cache.loadSpace(0, (list) => {
    //   this.spaces = list;
    //   if (this.spaces.length) {
    //     this.space = this.spaces[0];
    //   }
    // });
  }
  updateLocation() {
    this.space = this.spaces.find((c) => c.location.id == this.location.id)
    this.refresh();
  }
  ngOnInit() { }
  @ViewChild('calendar') calendar: DayViewTimeComponent;
  refresh() {
    this.calendar.refresh();
  }

  prev() {
    this.date = this.date.clone().add(-7, 'day');
    this.refresh();
  }

  next() {
    this.date = this.date.clone().add(7, 'day');
    this.refresh();
  }
  start: moment.Moment;
  end: moment.Moment;
  loadData(event: DayViewTimeLoad) {
    // if (!this.location) return;
    let start = this.date.clone().startOf('date');
    let end = start.clone().add(1, 'day');

    start = date_utils.getFirstDayOfWeek(start);
    end = start.clone().add(7, 'day');
    this.start = start;
    this.end = end;
    let lang = this.session?.lang ?? 'zh_hk';

    // let d = moment(this.viewDate);
    // const date = date_utils.getFirstDayOfWeek(d);
    // const start = date_utils.toQuery(date);
    // const end = date_utils.toQuery(date.clone().add(6, 'day'));

    WebUtils.web_list(
      this.http.post('/api/client/booking/list/calendar', {
        start,
        end,
        status: [TBookingStatus.approved, TBookingStatus.pending],
        space: WebUtils.objId(this.space),
      }),
      (result) => {
        let d = start.clone();
        let dates = [];
        while (d.isBefore(end)) {
          dates.push(d.clone());
          d = d.add(1, 'day');
        }

        event.comp.setColumns([
          ...dates.map((d) => {
            return {
              id: d.format('YYYY-MM-DD'),
              // title: d.format('YYYY-MM-DD'),
              title: Thinkdesks.dateFormat2(d, lang),
              lines: [d.format('ddd')],
            };
          }),
        ]);

        let list = result as TBooking[];
        for (let o of list) AccessUtils.fixBooking(o);

        for (let d of dates) {
          let id = d.format('YYYY-MM-DD');

          let _schedules: DaySection[] = this.extractDay(d, result, list);
          let schedules: DaySection[] = [];
          let merged: DaySection[][] = [];

          for (let i = 0; i < _schedules.length; i++) {

            let oo = _schedules[i];
            let overlaps = [];
            for (let j = i + 1; j < _schedules.length; j++) {
              let o = _schedules[j];
              if (this.overlaps(oo, o)) {
                _schedules.splice(j, 1);
                overlaps.push(o);
                j--;
              }
            }
            if (!overlaps.length) {
              schedules.push(oo);

            } else {
              overlaps.splice(0, 0, oo);
              merged.push(overlaps);
            }
          }

          this.addDay(event, id, schedules, {
            title: (s) => {
              return [{ text: `${_common.BookingPerson}: ${s.data?.member?.name}` }];
            },
            timeTitle: (start, end) => {
              let now = moment();
              let _start = start.moment(now);
              let _end = end.moment(now);
              return [
                {
                  text: `${_start.format(Thinkdesks.timeFormat)}-${_end.format(
                    Thinkdesks.timeFormat
                  )}`,
                },
              ];
            },
            color: (s) => {
              if (s.data.status == TBookingStatus.pending) {
                return {
                  color: this.bookedColor,
                  borderColor: this.bookedBorder,
                };
              }
              return null;
            },
          });
          for (let oo of merged) {
            let s = oo[0];

            let start = TimeAtom.parse(s.start);
            let end = TimeAtom.parse(s.end);
            let color = this.availableColor;
            let borderColor = this.availableBorder;
            let textColor = '#000000';

            event.comp.addData(id, {
              start: TimeAtom.parse(s.start),
              end: TimeAtom.parse(s.end),
              title: `${oo.length} ${_common.Bookings}`,
              color,
              borderColor,
              textColor,
              lines: [
                { text: `${start.toString()}-${end.toString()}` }
              ],
              data: {
                list: oo,
              },
            });
          }
        }
      }
    );
  }

  extractDay(date: moment.Moment, result, list: TBooking[]) {
    // let schedule = this.scheduleManager.resolveResourceSchedule(this.object, this.location.location, date)

    let schedules: DaySection[] = [];

    // this.merge(schedules, {
    //   start: 0,
    //   end: 2400,
    //   qty: 2,
    // });

    for (let oo of list) {
      let dd = oo.startTime.clone().startOf('day');
      if (!dd.isSame(date)) continue;

      let o = {
        start: TimeAtom.fromMoment(oo.startTime).toTime(),
        end: TimeAtom.fromMoment(oo.endTime).toTime(),
        qty: NaN,
        data: oo,
        text: [
          //`1 + ${+ oo.participants.filter((c) => !c.walkin).length}`
          `${1 + oo.numParticipants} ${_common.participant_users}`
        ],
      } as DaySection;
      //
      schedules.push(o);

      // this.merge(schedules, o);
    }
    // if (schedule) {
    //   for (let slot of schedule.slots) {
    //     this.merge(schedules, {
    //       start: slot.start.toTime(),
    //       end: slot.end.toTime(),
    //       qty: this.namedResource ? 1 : this.location.qty,

    //     })
    //   }
    // }

    this.clean(schedules);
    return schedules;
  }
  // extractBookings(list: TAccessEntry[]) {
  //   let bookings = [];
  //   let cache: { [key: number]: any } = {};
  //   for (let o of list) {

  //     let date = o.startTime.clone().startOf('day');

  //     let booking = cache[o.bookingId]
  //     if (!booking) {
  //       booking = {
  //         id: o.bookingId,
  //         title: o.bookingName,
  //         items: []
  //       } as any;
  //       cache[o.bookingId] = booking
  //       bookings.push(booking);
  //     }
  //     let c = booking.items.find((c) => c.time == o.time && c.endTime == o.endTime)
  //     if (c) {
  //       c.qty += c.qty;
  //     } else {
  //       booking.items.push(o);
  //     }
  //   }
  //   return bookings;
  // }
  _oo = false;
  openItem(event: {
    column: DayViewTimeColumn;
    // row: DayViewTimeRow;
    item: DayViewTimeItem;
  }) {
    let data = event.item.data;
    if (data.list) {
      let ref = this.dialog.open(BookingSelectDialog, {
        data: {
          objects: data.list.map((c) => c.data)
        }
      })
      ref.afterClosed().subscribe((result) => {
        if (result) {
          const ref = this.dialog.open(BookingDialogComponent, {
            data: {
              objectId: result.id,
            },
          });
          ref.afterClosed().subscribe((result) => {
            if (result) {
              this.refresh();
            }
          });
        }
      })
    } else {

      const ref = this.dialog.open(BookingDialogComponent, {
        data: {
          objectId: event.item.data.schedule.data.id,
        },
      });
      ref.afterClosed().subscribe((result) => {
        if (result) {
          this.refresh();
        }
      });
    }
  }

  openTime(event: { column: DayViewTimeColumn; row: DayViewTimeRow }) {
    console.log(event);
    // const dialogRef = this.dialog.open(BookingSpaceDialog, {
    //   data: {
    //     objectId: this.space.id,
    //   },
    // });
  }

  add() {
    // let ref = this.dialog.open(BookingSpaceSelectDialogComponent, {
    //   data: {},
    // });
    // ref.afterClosed().subscribe((result) => {
    //   if (result) {
    //     let ref = this.dialog.open(BookingSpaceDialog, {
    //       data: {
    //         objectId: result.id,
    //       },
    //     });
    //     ref.afterClosed().subscribe((result) => {});
    //   }
    // });
  }
}
